/**
 * @overview 主应用路由
 */
import Index from '@/views/Index'; // 首页校区信息
/**
 * 校区管理
 */
import DepartmentConfig from '@/views/DepartmentConfig'; // 参数设置
import Staff from '@/views/Staff'; // 员工管理
import BranchSchool from '@/views/BranchSchool'; // 分校管理
/**
 * 计费中心
 */
import Account from '@/views/Account'; // 账户管理
import Waterlist from '@/views/Waterlist'; // 账户流水
import Bill from '@/views/Bill'; // 校区账单

/**
 * 上课统计
 */
import Statistical from '@/views/Statistical/router'; // 消费统计
import ClassLog from '@/views/ClassLog'; // 上课日志
/**
 * 课件管理
 */
import Courseware from '@/views/Courseware'; // 资源管理
import CoursewareAi from '@/views/CoursewareAI'; // 互动课件管理
/**
 * 老师管理
 */
import Teacher from '@/views/Teacher'; // 老师管理
/**
 * 班级管理
 */
import ClassManage from '@/views/ClassManage'; // 班级管理
/**
 * 学生管理
 */
import Student from '@/views/Student'; // 学生管理
/**
 * 代理商中心
 */
import FactorCampus from '@/views/FactorCampus'; // 代理商中心
/**
 * 商品中心
 */
import Goods from '@/views/Goods/router'; // 课程商品
import MyClass from '@/views/MyClass/router'; // 课程商品
/**
 * 课程分销数据
 */
import CourseDistribution from '@/views/CourseDistribution/router'; // 课程分销数据
// 我的课程
import MyCourse from '@/views/MyCourse/router';
// 课程上架
import CourseOn from '@/views/CourseOn/router';
// 课程统计
import CourseStatistics from '@/views/CourseStatistics/router';

const routes = [
  ...Index,
  ...DepartmentConfig,
  ...Staff,
  ...BranchSchool,
  ...Account,
  ...Waterlist,
  ...Bill,
  ...Statistical,
  ...ClassLog,
  ...Courseware,
  ...CoursewareAi,
  ...Teacher,
  ...ClassManage,
  ...Student,
  ...FactorCampus,
  ...Goods,
  ...MyClass,
  ...CourseDistribution,
  ...MyCourse,
  ...CourseOn,
  ...CourseStatistics,
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/main.js